import React, { FC } from 'react';

import AppLayout from '../../AppLayout';
import AppLayoutRow from '../../AppLayoutRow';

import FooterRow from './FooterRow';
import HeaderRow from './HeaderRow';
import MainAreaRow from './MainAreaRow';
import SubHeaderRow from './SubHeaderRow';
import { TemplateProps } from './Template.types';

const Template: FC<TemplateProps> = ({
  header,
  subHeader,
  banner,
  footer,
  mainAreaBackgroundSrc,
  children,
  leftNav,
  openContentSidebarAriaLabel,
  closeContentSidebarAriaLabel,
}) => {
  const bannerRow = banner ? <AppLayoutRow>{banner}</AppLayoutRow> : null;
  const footerRow = footer ? <FooterRow>{footer}</FooterRow> : null;

  return (
    <AppLayout
      disableNativePageScroll={true}
      closeContentSidebarAriaLabel={closeContentSidebarAriaLabel}
      openContentSidebarAriaLabel={openContentSidebarAriaLabel}
      height="100dvh"
    >
      <HeaderRow>{header}</HeaderRow>
      <SubHeaderRow>{subHeader}</SubHeaderRow>
      {bannerRow}
      <MainAreaRow leftNav={leftNav} mainAreaBackgroundSrc={mainAreaBackgroundSrc}>
        {children}
      </MainAreaRow>
      {footerRow}
    </AppLayout>
  );
};

export default Template;
